<div class="px-3">
  <!-- Header -->
  <div class="search-results-header">
    <div class="search-results-title">
      <h2>{{ 'searchResults.title' | translate }}</h2>
    </div>
  </div>

  <!-- Deep (content) results -->
  @if (query().trim().length >= 2) {
    <div class="row">
      <!-- Filters Section -->
      <div class="col-3">
        <ap-panel [bordered]="true">
          <div class="pt-3">
            @if (isLoadingData()) {
              <ng-container *ngTemplateOutlet="skeletonFilter"></ng-container>
              <ng-container *ngTemplateOutlet="skeletonFilter"></ng-container>
            } @else {
              <!-- Section filter -->
              <div class="filter-control-row pb-3">
                <div class="filter-master-checkbox">
                  <ap-checkbox
                    inputId="select-all-sections"
                    [ngModel]="sectionMasterState().checked"
                    [indeterminate]="sectionMasterState().indeterminate"
                    [disabled]="sectionMasterState().disabled"
                    [ariaLabel]="'searchResults.selectAll' | translate"
                    (onChange)="
                      toggleAllFilters('section', $event.checkboxState)
                    " />
                </div>
                <ap-filter
                  [isMultiSelectable]="true"
                  [data]="filterSectionData()"
                  [headerName]="'searchResults.FilterBySection' | translate"
                  [expand]="false">
                  @for (item of filterSectionData(); track $index) {
                    <ap-filter-item
                      [item]="item"
                      (onClick)="onEnterForCheckbox(item, 'section')"
                      [role]="'checkbox'">
                      <ap-checkbox
                        [(ngModel)]="item.checked"
                        [disabled]="item.disabled"
                        (onChange)="onCheckboxSelected($event, item, 'section')"
                        [tabindex]="-1"></ap-checkbox>
                    </ap-filter-item>
                  }
                </ap-filter>
              </div>

              <!-- Country Filter -->
              <div class="filter-control-row pb-3">
                <div class="filter-master-checkbox">
                  <ap-checkbox
                    inputId="select-all-countries"
                    [ngModel]="countryMasterState().checked"
                    [indeterminate]="countryMasterState().indeterminate"
                    [disabled]="countryMasterState().disabled"
                    [ariaLabel]="'searchResults.selectAll' | translate"
                    (onChange)="
                      toggleAllFilters('country', $event.checkboxState)
                    " />
                </div>
                <ap-filter
                  [isMultiSelectable]="true"
                  [data]="filterCountryData()"
                  [headerName]="'searchResults.FilterByCountry' | translate"
                  [expand]="false">
                  @for (item of filterCountryData(); track $index) {
                    <ap-filter-item
                      [item]="item"
                      (onClick)="onEnterForCheckbox(item, 'country')"
                      [role]="'checkbox'">
                      <ap-checkbox
                        [(ngModel)]="item.checked"
                        [disabled]="item.disabled"
                        (onChange)="onCheckboxSelected($event, item, 'country')"
                        [tabindex]="-1"></ap-checkbox>
                    </ap-filter-item>
                  }
                </ap-filter>
              </div>
            }
          </div>
        </ap-panel>
      </div>

      <!-- Results and Pagination section Section -->
      <div class="col-9">
        <ap-panel [bordered]="true">
          <div class="deep-search-section pt-3">
            <div class="deep-search-header pb-3">
              @if (isLoadingData()) {
                <h3 class="group-title">
                  <p-skeleton width="100%" height="2rem" borderRadius="4px" />
                </h3>
              } @else {
                <h3 class="group-title">
                  {{ deepSearchTotal() }}
                  {{
                    deepSearchTotal() === 1
                      ? ('searchResults.singleReult' | translate)
                      : ('searchResults.resultsCount' | translate)
                  }}
                  <strong>&ldquo;{{ query() }}&rdquo;</strong>
                  {{
                    filteredDeepSearchTotal() !== deepSearchTotal()
                      ? '&mdash;' +
                        filteredDeepSearchTotal() +
                        ' ' +
                        ('searchResults.filteredResults' | translate)
                      : ''
                  }}
                </h3>
              }
            </div>

            <!-- Results Section -->
            @if (isLoadingData()) {
              <div class="deep-search-loading">
                <!-- Loading 5 blocks to display skeletons -->
                @for (_ of [1, 2, 3, 4, 5]; track $index) {
                  <p-skeleton width="100%" styleClass="mb-2" height="10rem">
                  </p-skeleton>
                }
              </div>
            } @else if (deepSearchResult() && filteredDeepSearchTotal() > 0) {
              <div class="deep-search-results">
                @for (
                  item of filteredDeepSearchItems();
                  track item.generalCountryInformationId
                ) {
                  <button
                    type="button"
                    class="deep-result-card"
                    (click)="
                      navigateToContent(
                        item.countryId,
                        item.generalCountryInformationTypeId
                      )
                    ">
                    <div class="deep-result-meta">
                      <span
                        class="deep-result-country ap-typography-body-m ap-font-weight-3"
                        >{{ item.countryName }}</span
                      >
                      <span class="deep-result-separator">&mdash;</span>
                      <span
                        class="deep-result-type ap-typography-body-m ap-font-weight-3"
                        >{{ item.generalCountryInformationTypeName }}</span
                      >
                    </div>
                    <p
                      class="deep-result-snippet ap-typography-body"
                      [innerHTML]="
                        formatResultToBoldSearchQuery(item.snippet)
                      "></p>
                    <span
                      class="Appkit4-icon icon-right-chevron-outline card-arrow"></span>
                  </button>
                }
              </div>
            } @else if (deepSearchResult()) {
              <div class="deep-search-empty">
                <p class="ap-typography-body">
                  {{
                    (deepSearchTotal() === 0
                      ? 'searchResults.deepSearchNoResults'
                      : 'searchResults.noFilteredResults'
                    ) | translate
                  }}
                </p>
              </div>
            }
          </div>
        </ap-panel>

        <ap-panel class="mt-3">
          <!-- Paginator -->
          @if (isLoadingData()) {
            <div
              class="d-flex justify-content-between align-items-center flex-wrap gap-3 pt-3">
              <div class="d-flex justify-content-start align-items-center ml-3">
                <p-skeleton width="200px" height="3rem" borderRadius="2px" />
              </div>
              <div
                class="d-flex justify-content-end align-items-center gap-2 ms-auto">
                <p-skeleton width="40px" height="2rem" borderRadius="4px" />
                <p-skeleton width="100px" height="3rem" borderRadius="6px" />
                <p-skeleton width="80px" height="2rem" borderRadius="4px" />
              </div>
            </div>
          } @else {
            <div class="pt-3">
              <div
                class="paginator d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div
                  class="left-elements d-flex justify-content-start align-items-center">
                  <ap-pagination
                    [ngModel]="pageIndex()"
                    [max]="maxPageIndex()"
                    (onChange)="updatePaginatorStep($event)"></ap-pagination>
                </div>
                <div
                  class="right-elements d-flex justify-content-end align-items-center gap-3 ms-auto">
                  <label for="itemsPerPage" class="ap-pagination-options-show"
                    >Show</label
                  >
                  <div
                    class="items-per-page-dropdown d-flex align-items-center">
                    <ap-dropdown
                      class="page-count-dropdown"
                      [styleClass]="'page-count-dropdown'"
                      [list]="pageCountOptions()"
                      [selectType]="'single'"
                      [hideTitleOnInput]="true"
                      [title]="''"
                      [required]="false"
                      [enableNgContent]="false"
                      [ngModel]="itemsPerPage()"
                      (onSelect)="onCountChange($event)">
                    </ap-dropdown>
                  </div>
                  <span class="ap-pagination-items-per-page">Items / Page</span>
                </div>
              </div>
            </div>
          }
        </ap-panel>
      </div>
    </div>
  }
</div>

<!-- Reusable skeleton template for filters -->
<ng-template #skeletonFilter>
  <!-- Loading a header and 5 blocks to display skeletons -->
  <div
    class="d-flex justify-content-between align-items-center flex-wrap gap-3 pt-3">
    <p-skeleton width="50%" styleClass="mb-2" height="2rem"> </p-skeleton>
    <p-skeleton width="2rem" styleClass="mb-2" height="2rem"> </p-skeleton>
  </div>
  @for (_ of [1, 2, 3, 4, 5]; track $index) {
    <p-skeleton width="100%" styleClass="mb-2" height="2rem"> </p-skeleton>
  }
</ng-template>
